import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import ProductUploads from './modules/ProductUploads/ProductUploads';
import AssetMappings from './modules/AssetMappings/AssetMappings';
import MappedAssets from './modules/MappedAssets/MappedAssets';
import EditForm from './components/uploads/EditForm';
import Form from './components/uploads/Form';
import { paths } from 'routes';

const RootRoutes: React.FC = () => {
  return (
    <Switch>
      <Route exact path={paths.productUploads} component={ProductUploads} />
      <Route exact path={paths.assetMappings} component={AssetMappings} />
      <Route exact path={paths.mappedAssets} component={MappedAssets} />
      <Route exact path={paths.newProductUpload} component={Form} />
      <Route exact path={paths.editProductUpload} render={(props) => <EditForm {...props} />} />
      <Redirect to={paths.productUploads} />
    </Switch>
  );
};

export default RootRoutes;
